export default "__VITE_ASSET__D11_E7Gl__"